// Chemical formulas in test and parameter names: the digit in O2, CO2 and HCO3 is set as a subscript.
import { Fragment, type ReactNode } from 'react';

const RE = /(HCO|CO|O)(\d)\b/g;

export function chem(text: string): ReactNode {
  const parts: ReactNode[] = [];
  let last = 0;
  for (const m of text.matchAll(RE)) {
    const i = m.index ?? 0;
    parts.push(text.slice(last, i), m[1], <sub key={i} className="rx-sub">{m[2]}</sub>);
    last = i + m[0].length;
  }
  if (!parts.length) return text;
  parts.push(text.slice(last));
  return <Fragment>{parts}</Fragment>;
}
